export default function FAQ() {
  return (
    <main className="max-w-2xl mx-auto py-16 px-4">
      <h1 className="text-3xl font-bold mb-4 text-gray-900">Frequently Asked Questions</h1>
      <div className="space-y-6">
        <div>
          <h2 className="text-xl font-semibold text-orange-700 mb-1">What is HollerFinds?</h2>
          <p className="text-gray-700">Your Neighborhood's Map for Yard Sales, Free Finds & Front Porch Pickups. We help neighbors share and discover local treasures.</p>
        </div>
        <div>
          <h2 className="text-xl font-semibold text-orange-700 mb-1">Is it free to use?</h2>
          <p className="text-gray-700">Yes! It's free to post, browse, and discover — just bring a little kindness.</p>
        </div>
        <div>
          <h2 className="text-xl font-semibold text-orange-700 mb-1">How do I list something?</h2>
          <p className="text-gray-700">Snap a pic, add a quick note, and pin it to the map. Free stuff, sales, or pop-ups — it's your holler.</p>
        </div>
        <div>
          <h2 className="text-xl font-semibold text-orange-700 mb-1">Can I use HollerFinds outside Chattanooga?</h2>
          <p className="text-gray-700">We're starting in Chattanooga, but hope to expand soon! Let us know if you want HollerFinds in your town.</p>
        </div>
      </div>
    </main>
  );
} 